import { Home } from "./components/Home/Home";


function App() {
  return (
    <div className="App">
      {/* <Router>
      {/* <Home/> */}

     
            <Home />
 
    </div>
  );
}

export default App;
